import { FunctionComponent, memo } from 'react';
import { StoryCardEditorialContent } from '../../../../services';
import { HorizontalStoryFeedCardProps, HorizontalStoryFeedContentCommon } from '../../../../shared';
import { HorizontalStoryFeedAdminCardWrapper } from '../HorizontalStoryFeedAdminCardWrapper';

export const HorizontalStoryFeedAdminEditorial: FunctionComponent<HorizontalStoryFeedCardProps> =
  memo(({ card }) => {
    const { content, isPinnedToTopOfNewsFeed, isPinnedToTopOfStory } = card;
    const { sourceName, headline, subHeadline, text, textHTML } =
      content as StoryCardEditorialContent;

    return (
      <HorizontalStoryFeedAdminCardWrapper card={card}>
        <HorizontalStoryFeedContentCommon
          isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
          isPinnedToTopOfStory={isPinnedToTopOfStory}
          source={sourceName}
          title={headline}
          subTitle={subHeadline}
          text={text}
          htmlText={textHTML}
        ></HorizontalStoryFeedContentCommon>
      </HorizontalStoryFeedAdminCardWrapper>
    );
  });
